import { GlobalState } from '@leverege/ui-redux';
import { ItemDelegate, Relationship } from '@leverege/molten/imagine';
import { startOfMonth, endOfMonth, subMonths } from 'date-fns';
async function getCompanyId(locationId) {
  const relationship = Relationship.createItemRelationship(Relationship.getByPath('location'));
  const actions = new ItemDelegate({
    relationship,
    id: locationId,
    match: {
      params: {
        locationId
      }
    },
    ttl: 30000
  });
  let location = actions.getItem(GlobalState.get(), true);
  if (!location) {
    location = await GlobalState.dispatch(actions.get());
  }
  return location?.data?.company?.id;
}
function addOffsetForDatefns(date) {
  const dateMs = date.getTime();
  const offsetMs = date.getTimezoneOffset() * 60 * 1000;
  const dateWithOffset = new Date(dateMs + offsetMs);
  return dateWithOffset;
}
function removeOffsetForDatefns(date) {
  const dateMs = date.getTime();
  const offsetMs = date.getTimezoneOffset() * 60 * 1000;
  const dateWithoutOffset = new Date(dateMs - offsetMs);
  return dateWithoutOffset;
}
function calculateWithOffset(date, dateFnsMethod, option) {
  const initialDateWithOffset = addOffsetForDatefns(date);
  const calculatedDateWithOffset = dateFnsMethod(initialDateWithOffset, option);
  const caluclatedDateWithoutOffset = removeOffsetForDatefns(calculatedDateWithOffset);
  return caluclatedDateWithoutOffset;
}
function calculateUTCStartOfMonth(date) {
  return calculateWithOffset(date, startOfMonth);
}
function calculateUTCEndOfMonth(date) {
  return calculateWithOffset(date, endOfMonth);
}
function calculateUTCSubMonths(date, numMonths) {
  return calculateWithOffset(date, subMonths, numMonths);
}
function billableSaleQueryTerms() {
  return [{
    type: 'equals',
    field: 'data/type',
    value: ['vehicle-with-locator']
  }, {
    // Only include sales that include a locator (ie not a key tag only sale),
    // including those that were made before the "productTypes" field was added
    type: 'logical',
    operator: 'or',
    conditions: [{
      type: 'equals',
      field: 'data/productTypes/recovr',
      value: true
    }, {
      type: 'exists',
      field: 'data/productTypes/recovr',
      not: true
    }]
  }];
}
function buildRecovrSalesFilter(invoiceIds) {
  return {
    type: 'logical',
    operator: 'and',
    conditions: [{
      type: 'equals',
      field: 'data/invoices/sold',
      value: invoiceIds
    }, {
      type: 'equals',
      field: 'data/invoices/void',
      value: invoiceIds,
      not: true
    }, ...billableSaleQueryTerms()]
  };
}
function buildRecovrRefundsFilter(invoiceIds) {
  return {
    type: 'logical',
    operator: 'and',
    conditions: [{
      // a sale from before this month
      type: 'equals',
      field: 'data/invoices/sold',
      value: invoiceIds,
      not: true
    },
    // that was voided this month
    {
      type: 'equals',
      field: 'data/invoices/void',
      value: invoiceIds
    }, {
      type: 'equals',
      field: 'data/state',
      value: ['void']
    }, ...billableSaleQueryTerms()]
  };
}
function buildFoundLocatorsFilter(invoiceIds) {
  return {
    type: 'logical',
    operator: 'and',
    conditions: [
    // found this month
    {
      type: 'equals',
      field: 'data/found/foundInvoiceId',
      value: invoiceIds
    }]
  };
}
function buildLostLocatorsFilter(invoiceIds) {
  return {
    type: 'logical',
    operator: 'and',
    conditions: [{
      type: 'equals',
      field: 'data/lost/lostInvoiceId',
      value: invoiceIds
    }]
  };
}
export { getCompanyId, calculateUTCStartOfMonth, calculateUTCEndOfMonth, calculateUTCSubMonths, buildRecovrSalesFilter, buildRecovrRefundsFilter, buildFoundLocatorsFilter, buildLostLocatorsFilter };